import React from 'react';
import classnames from 'classnames';

const styles = require('./quote-component.styles.scss');


export const QuoteComponent = ({ children, className, author }) => {
  const classname = classnames(className, styles.Quote);

  return (
    <div className={classname}>
      <div className={styles.LeftBar}>
        <div className={styles.Text}>{ children }</div>
        <div className={styles.Author}>{ author }</div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/quote/quote.component.jsx